function updatePillButtons() {
    const pillButtons = document.querySelectorAll(".pill");
    pillButtons.forEach(button => {
        button.addEventListener("click", function() {
            pillButtons.forEach(innerButton => {
                innerButton.classList.remove("selected");
            });
            
            this.classList.add("selected");

            centerButton(this);

            const digitalSearchJSONurl = this.dataset.url;
            const activeSearchUrl = document.getElementById('active-search-url');
            activeSearchUrl.value = digitalSearchJSONurl;

            fetchSearchPage(digitalSearchJSONurl);
        });
    });
}


function fetchSearchPage(url, offset) {
    if(!!offset) {
        $("html").animate({
            scrollTop: $('.selector-container')[0].offsetTop
        }, "slow");
    }
    fetch(offset ? url + '&offset=' + offset : url)
        .then(response => response.text())
        .then(data => {
            document.getElementById('selector-container').innerHTML = data;
            if (document.getElementById('paging').value) {
                updatePagination();
                updatePillButtons();
            }
        })
        .catch(error => {
            console.error("There was an error with the fetch operation:", error);
        });
}

function updatePagination() {
    const { total, size, start } = JSON.parse(document.getElementById('paging').value);
    const activeSearchUrl = $('#active-search-url').val();
    const numberOfButtons = 4;
    const totalPages = Math.floor(total / size);
    const currentPage = Math.floor(start / size);

    const paginationTextDiv = document.getElementById('paginationText');
    paginationTextDiv.innerHTML = `${start < total ? start + 1 : start} - ${Math.min(start+size, total)} of ${total}`;

    const paginationBarDiv = document.getElementById('paginationbar');
    paginationBarDiv.innerHTML = '';

    let showDotDotDot = false;
    if (currentPage + numberOfButtons < totalPages) {
        showDotDotDot = true
    }

    const prevButton = document.createElement('button');
    prevButton.onclick = () => fetchSearchPage(activeSearchUrl, (currentPage - 1) * 20);
    prevButton.disabled = currentPage === 0;
    prevButton.className = 'arrow prev-arrow'
    paginationBarDiv.appendChild(prevButton);
    
    const makePageButton = (i) => {
        const pageButton = document.createElement('button');
        pageButton.textContent = i + 1;
        pageButton.disabled = i === currentPage;
        pageButton.onclick = () => fetchSearchPage(activeSearchUrl, (i) * 20);
        pageButton.className = `pages-num ${i === currentPage ? 'selected' : ''}`;
        paginationBarDiv.appendChild(pageButton);
    }

    const makeDots = () => {
        const dotdotdotDiv = document.createElement('div');
        dotdotdotDiv.className = 'pages-dots';
        dotdotdotDiv.textContent = "...";
        paginationBarDiv.appendChild(dotdotdotDiv);
    }
    
    const lastPageOption = Math.min(currentPage < 4 ? Math.min(currentPage + 4, 5) : currentPage + 2, totalPages);
    const firstOption = Math.max(currentPage < totalPages - 2 ?  currentPage - 1 : currentPage - 3, 1);
    makePageButton(0)
    if (firstOption > 1) {
        makeDots();
    }
    for (let i = firstOption; i < lastPageOption; i++) {
        makePageButton(i)
    }
    if (lastPageOption < totalPages) {
        makeDots();
    }
    if (firstOption <= lastPageOption) {
        makePageButton(totalPages);
    }

    const nextButton = document.createElement('button');
    nextButton.onclick = () => fetchSearchPage(activeSearchUrl, (currentPage + 1) * 20);
    nextButton.disabled = currentPage === totalPages;
    nextButton.className = 'arrow next-arrow'
    paginationBarDiv.appendChild(nextButton);
}

function centerButton(button) {
    const container = document.querySelector(".pill-container");
    const containerWidth = container.clientWidth;
    const buttonWidth = button.clientWidth;
    const buttonOffsetLeft = button.offsetLeft;

    const scrollLeft = buttonOffsetLeft - (containerWidth / 2) + (buttonWidth / 2);
    
    container.scrollLeft = scrollLeft;
}

window.toggleSortDropdown = function() {
    document.getElementById("sort-dropdown-content").classList.toggle("show");
}

window.onclick = function(event) {
    if (!(event.target.matches('.sort-dropdown-btn') || event.target.matches('.sort-dropdown-btn-span'))) {
        var dropdowns = document.getElementsByClassName("sort-dropdown-content");
        for (var i = 0; i < dropdowns.length; i++) {
            var openDropdown = dropdowns[i];
            if (openDropdown.classList.contains('show')) {
                openDropdown.classList.remove('show');
            }
        }
    }
}

var initialTileUrl = $('#active-search-url').val();

if (initialTileUrl) {
    fetchSearchPage(initialTileUrl);
} else {
    const targetNode = document.getElementsByTagName("body")[0];
    const config = { attributes: true, childList: true, subtree: true };
    const callback = function(mutationsList, observer) {
        for(const mutation of mutationsList) {
            var url = $('#active-search-url').val();
            if ( url ){
                fetchSearchPage(url);
                observer.disconnect();
            }
        }
    };
    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
}